import { TrackingSetting } from 'backend';
import { ROOT_ELEMENT_ID, TRACKING_SCRIPT_ELEMENT_ID } from 'models';
import { useEffect } from 'react';

const tracking = ({
  clientSchema,
  jsPath,
  formTrackingData,
  trackingTagParam,
}: TrackingSetting): void => {
  window.__synergy_form_tdata = formTrackingData ?? undefined;
  window.__tdata = trackingTagParam ?? undefined;
  const script = document.createElement('script');
  const src = `${jsPath}?id=${clientSchema}`;
  script.id = TRACKING_SCRIPT_ELEMENT_ID;
  script.src = src;
  script.async = true;
  const rootEl = document.getElementById(ROOT_ELEMENT_ID);
  if (rootEl) {
    rootEl.parentNode?.insertBefore(script, rootEl.nextSibling);
  }
};

const removeTracking = () => {
  window.__synergy_form_tdata = undefined;
  window.__tdata = undefined;
  const script = document.getElementById(TRACKING_SCRIPT_ELEMENT_ID);
  const rootEl = document.getElementById(ROOT_ELEMENT_ID);
  if (!rootEl || !script) {
    return;
  }
  rootEl.parentNode?.removeChild(script);
};

type UseTrackingPayload = TrackingSetting;

export const useTracking = (trackingSetting?: UseTrackingPayload): void => {
  useEffect(() => {
    if (!trackingSetting) {
      return;
    }
    tracking(trackingSetting);
    return removeTracking;
  }, [trackingSetting]);
};
